import mondaySdk from 'monday-sdk-js'
import Dropdown from 'monday-ui-react-core/dist/Dropdown'
import Deactivate from 'monday-ui-react-core/dist/icons/Deactivate'
import { restrcitorService } from './restrictorService'
const monday = mondaySdk()
monday.setApiVersion('2024-10')

const getBoardColumnsAndGroups = async ({ board }) => {
  const notSupportedColTypes = ['last_updated', 'formula', 'progress', 'button', 'subtasks', 'pulse-updated', 'columns-battery']

  try {
    if (board?.value) {
      const query = `query{
          boards(ids: ${board.value}){
            groups{
              id
              title
              color
            }
            columns{
              id
              type
              title
              settings_str
            }
          }
        }`
      const res = await monday.api(query)
      const columns = res.data.boards[0].columns
      const groups = res.data.boards[0].groups

      const filteredColumns = []
      if (columns?.length) {
        for (let i = 0; i < columns.length; i++) {
          const col = columns[i]

          if (col.type === 'lookup' || col.type === 'mirror') {
            // Mirror column - check the actual type if supported

            const settings_str = JSON.parse(col.settings_str)
            if (!Object.keys(settings_str).length || !Object.keys(settings_str.displayed_linked_columns).length) continue // in case the settings_str or displayed_linked_columns === {} / no board connected to the mirror
            const [designatedBoardId, designatedColumnId] = Object.entries(JSON.parse(col.settings_str).displayed_linked_columns)[0]

            if (!designatedColumnId || !designatedColumnId.length) continue // in case no column connected to the mirror

            const query = `query {
                boards(ids: ${designatedBoardId}) {
                     columns(ids: "${designatedColumnId}") {
                    type
                 }
                }
              }`
            const res = await monday.api(query)
            const boardColumns = res.data.boards[0]?.columns

            if (!boardColumns || !boardColumns.length || !boardColumns[0]?.type) continue
            else if (!notSupportedColTypes.includes(boardColumns[0].type)) {
              // Exclude unsupported columns
              filteredColumns.push(col)
              continue
            }
          } else if (col.title !== 'Name' && !notSupportedColTypes.includes(col.type)) {
            filteredColumns.push(col)
          } // Exclude unsupported columns
        }
      }

      const mappedColumns = filteredColumns.map((col) => {
        return { value: col.id, label: col.title }
      })

      const mappedGroups = groups?.map((group) => {
        return { value: group.id, label: group.title, leftIcon: () => <div className="circle" style={{ backgroundColor: group.color }}></div> }
      })
      return { columns: mappedColumns, groups: mappedGroups }
    }
  } catch (err) {
    console.log(`getBoardColumnsAndGroups -> err`, err)
  }
}

const getRestrictionLabels = async (restrictions, accountId, accessToken) => {
  try {
    const labeled = []
    for (let restriction of restrictions) {
      const groupId = restriction?.group?.value || restriction?.groupId
      const columnIds = restriction?.columns?.map((col) => col.id || col.value) || restriction?.columnIds

      const query = `query{ 
          boards(ids:${restriction.boardId || restriction.board.value}){
            name
            id
            groups(ids: [${JSON.stringify(groupId)} ]){
              title
              id
            }
            columns(ids:${JSON.stringify(columnIds)}){
              id
              title
            }
          }
        }`
      const res = await monday.api(query)
      const boardName = res.data.boards[0]?.name

      if (!res.data.boards[0]?.id) {
        // IN CASE USER DELETED BOARD
        console.log('board deleted / not found - deleting restriction')
        await restrcitorService.deleteRestriction(restriction._id, accountId, accessToken)
        continue
      }

      let group = null
      let columns = []
      if (!res.data.boards[0]?.groups[0]?.title || !restriction?.groupId) {
        // IN CASE USER DELETED GROUP
      } else {
        group = {
          label: res.data.boards[0]?.groups[0]?.title,
          value: restriction?.groupId,
        }
        columns = res.data?.boards[0]?.columns.map((col) => {
          return { value: col.id, label: col.title, chipColor: Dropdown.chipColors.NEGATIVE, leftIcon: Deactivate }
        })
      }

      labeled.push({
        board: {
          value: Number(restriction.boardId),
          label: boardName,
        },
        columns,
        group,
        _id: restriction._id,
      })
    }
    return labeled
  } catch (err) {
    console.log(`getRestrictionLabels -> err`, err)
    throw err
  }
}

const getBoards = async (setBoards, appMajorVersion, isShowSubBoards) => {
  try {
    let query = ''
    if (appMajorVersion >= 8) {
      query = `query
      {
        boards(limit:2500){
          name
          id
          type
        workspace {
          name
          settings {
            icon {
              color
              image
            }
          }
        }
      }
    }`
    } else {
      query = `query
    {
      boards(limit:2500){
        name
        id
        type
      }
    }`
    }
    const res = await monday.api(query)

    const boards = res.data.boards.filter((board) => {
      const isSubItemsBoard = board.type === 'sub_items_board'
      const isDocumentBoard = board.type === 'document'
      const shouldIncludeBoard = isShowSubBoards ? isSubItemsBoard && !isDocumentBoard : !isSubItemsBoard && !isDocumentBoard

      return shouldIncludeBoard
    })
    setBoards(boards)
  } catch (err) {
    console.log('file: mondayService.js:102 -> err', err)
    throw err
  }
}
const getCurrentBoards = async (currentBoardsId, setCurrentBoards) => {
  try {
    const query = `query
    {
      boards(ids: [${currentBoardsId}]){
        name
        id
      }
    }`
    const res = await monday.api(query)
    const boards = res.data.boards

    const mappedBoards = boards.map((board) => {
      return {
        label: board.name,
        value: board.id,
      }
    })

    setCurrentBoards(mappedBoards)
  } catch (err) {
    console.log('file: mondayService.js:102 -> err', err)
    throw err
  }
}
const getCurrentGroup = async (groupId, boardId, setCurrentGroup) => {
  try {
    const query = `query
    {
      boards(ids: ${boardId[0]}){
        groups(ids: "${groupId}") {
          title
          id
        }
      }
    }`
    const res = await monday.api(query)
    const group = res.data.boards[0].groups.map((group) => {
      return {
        label: group.title,
        value: group?.id,
      }
    })

    setCurrentGroup(group)
  } catch (err) {
    console.log('file: mondayService.js:102 -> err', err)
    throw err
  }
}

const getAccount = async (setAccountInformation) => {
  try {
    const query = `{
      account {
        slug
        name
        id
      }
      me {
        id
        email
        name
      }
      users{
        is_guest
      }
    }`

    const res = await monday.api(query)
    const accountId = Number(res.data.account.id)
    const mondayDomain = res.data.account.slug
    const company = res.data.account.name
    const userId = res.data.me.id
    const userEmail = res.data.me.email
    const userName = res.data.me.name
    const mondayNumOfUsers = res.data.users.filter((user) => !user.is_guest)?.length

    setAccountInformation({
      accountId,
      mondayDomain,
      company,
      userId,
      userEmail,
      userName,
      mondayNumOfUsers,
    })
  } catch (err) {
    console.log('file: mondayService.js:122 -> err', err)
    throw err
  }
}

export const mondayService = {
  getBoardColumnsAndGroups,
  getRestrictionLabels,
  getBoards,
  getAccount,
  getCurrentBoards,
  getCurrentGroup,
}
